import _createForOfIteratorHelper from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _defineProperty from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module indent/indentblock
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import IndentBlockCommand from './indentblockcommand';
import IndentUsingOffset from './indentcommandbehavior/indentusingoffset';
import IndentUsingClasses from './indentcommandbehavior/indentusingclasses';
import { addMarginRules } from '@ckeditor/ckeditor5-engine/src/view/styles/margin';
/**
 * The block indentation feature.
 *
 * It registers the `'indentBlock'` and `'outdentBlock'` commands.
 *
 * If the plugin {@link module:indent/indent~Indent} is defined, it also attaches the `'indentBlock'` and `'outdentBlock'` commands to
 * the `'indent'` and `'outdent'` commands.
 *
 * @extends module:core/plugin~Plugin
 */

var IndentBlock = /*#__PURE__*/function (_Plugin) {
  _inherits(IndentBlock, _Plugin);

  var _super = _createSuper(IndentBlock);

  /**
   * @inheritDoc
   */
  function IndentBlock(editor) {
    var _this;

    _classCallCheck(this, IndentBlock);

    _this = _super.call(this, editor);
    editor.config.define('indentBlock', {
      offset: 40,
      unit: 'px'
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(IndentBlock, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var configuration = editor.config.get('indentBlock');
      var useOffsetConfig = !configuration.classes || !configuration.classes.length;
      var indentConfig = Object.assign({
        direction: 'forward'
      }, configuration);
      var outdentConfig = Object.assign({
        direction: 'backward'
      }, configuration);

      if (useOffsetConfig) {
        editor.data.addStyleProcessorRules(addMarginRules);

        this._setupConversionUsingOffset(editor.conversion);

        editor.commands.add('indentBlock', new IndentBlockCommand(editor, new IndentUsingOffset(indentConfig)));
        editor.commands.add('outdentBlock', new IndentBlockCommand(editor, new IndentUsingOffset(outdentConfig)));
      } else {
        this._setupConversionUsingClasses(configuration.classes);

        editor.commands.add('indentBlock', new IndentBlockCommand(editor, new IndentUsingClasses(indentConfig)));
        editor.commands.add('outdentBlock', new IndentBlockCommand(editor, new IndentUsingClasses(outdentConfig)));
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var indentCommand = editor.commands.get('indent');
      var outdentCommand = editor.commands.get('outdent'); // Enable block indentation by default in paragraph and default headings.

      var knownElements = ['paragraph', 'heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6'];
      knownElements.forEach(function (elementName) {
        if (schema.isRegistered(elementName)) {
          schema.extend(elementName, {
            allowAttributes: 'blockIndent'
          });
        }
      });
      indentCommand.registerChildCommand(editor.commands.get('indentBlock'));
      outdentCommand.registerChildCommand(editor.commands.get('outdentBlock'));
    }
    /**
     * Setups conversion for using offset indents.
     *
     * @private
     */

  }, {
    key: "_setupConversionUsingOffset",
    value: function _setupConversionUsingOffset() {
      var conversion = this.editor.conversion;
      var locale = this.editor.locale;
      var marginProperty = locale.contentLanguageDirection === 'rtl' ? 'margin-right' : 'margin-left';
      conversion.for('upcast').attributeToAttribute({
        view: {
          styles: _defineProperty({}, marginProperty, /[\s\S]+/)
        },
        model: {
          key: 'blockIndent',
          value: function value(viewElement) {
            return viewElement.getStyle(marginProperty);
          }
        }
      });
      conversion.for('downcast').attributeToAttribute({
        model: 'blockIndent',
        view: function view(modelAttributeValue) {
          return {
            key: 'style',
            value: _defineProperty({}, marginProperty, modelAttributeValue)
          };
        }
      });
    }
    /**
     * Setups conversion for using classes.
     *
     * @param {Array.<String>} classes
     * @private
     */

  }, {
    key: "_setupConversionUsingClasses",
    value: function _setupConversionUsingClasses(classes) {
      var definition = {
        model: {
          key: 'blockIndent',
          values: []
        },
        view: {}
      };

      var _iterator = _createForOfIteratorHelper(classes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var className = _step.value;
          definition.model.values.push(className);
          definition.view[className] = {
            key: 'class',
            value: [className]
          };
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.editor.conversion.attributeToAttribute(definition);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return 'IndentBlock';
    }
  }]);

  return IndentBlock;
}(Plugin);
/**
 * The configuration of the {@link module:indent/indentblock~IndentBlock block indentation feature}.
 *
 * Read more in {@link module:indent/indentblock~IndentBlockConfig}.
 *
 * @member {module:indent/indentblock~IndentBlockConfig} module:core/editor/editorconfig~EditorConfig#indentBlock
 */

/**
 * The configuration of the block indentation feature.
 *
 * If no {@link module:indent/indentblock~IndentBlockConfig#classes} are set, the block indentation feature will use
 * {@link module:indent/indentblock~IndentBlockConfig#offset} and {@link module:indent/indentblock~IndentBlockConfig#unit} to
 * create indentation steps.
 *
 *		ClassicEditor
 *			.create( editorElement, {
 * 				indentBlock: {
 *					offset: 2,
 *					unit: 'em'
 * 				}
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * Alternatively, the block indentation feature may set one of defined {@link module:indent/indentblock~IndentBlockConfig#classes} as
 * indentation steps:
 *
 *		ClassicEditor
 *			.create( editorElement, {
 * 				indentBlock: {
 *					classes: [
 *						'indent-a', // The first step - smallest indentation.
 *						'indent-b',
 *						'indent-c',
 *						'indent-d',
 *						'indent-e' // The last step - biggest indentation.
 *					]
 * 				}
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * In the example above only 5 indentation steps will be available.
 *
 * See {@link module:core/editor/editorconfig~EditorConfig all editor options}.
 *
 * @interface IndentBlockConfig
 */

/**
 * The size of indentation {@link module:indent/indentblock~IndentBlockConfig#unit units} for each indentation step.
 *
 * @default 40
 * @member {Number} module:indent/indentblock~IndentBlockConfig#offset
 */

/**
 * The unit used for indentation {@link module:indent/indentblock~IndentBlockConfig#offset}.
 *
 * @default 'px'
 * @member {String} module:indent/indentblock~IndentBlockConfig#unit
 */

/**
 * An optional list of classes to use for indenting the editor content. If not set or set to an empty array, no classes will be used.
 * The {@link module:indent/indentblock~IndentBlockConfig#unit `indentBlock.unit`} and
 * {@link module:indent/indentblock~IndentBlockConfig#offset `indentBlock.offset`} properties will be used instead.
 *
 * @default undefined
 * @member {Array.<String>|undefined} module:indent/indentblock~IndentBlockConfig#classes
 */


export { IndentBlock as default };